import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { findByAttr } from '../../versa/misc.js';
import router from '../../versa/router.js';
import { flatten, deepen } from '../../versa/record.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/price-lists.js';
import form from '../forms/price-lists.js';
import record from '../../versa/record.js';
import * as types from '../types.js';

const price_lists = function()
{

	let price_lists_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_customers, this.queryAll()).then((data) => db.set('customers', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			const q = (query || '').includes('?') ? `${query}&combined=1` : `${query || ''}?combined=1`;
			return await api.call(api.list_price_lists, q);
		},
		async loadRecord(id)
		{
			const arr = JSON.parse(id);
			if (arr[2] === 'customer') return null;
			let _record = await api.call(api.select_price_list, arr[0], arr[1]);
			return flatten(_record, 'prices');
		},
		async saveRecord(data, old_data)
		{
			data = deepen(data, 'prices');
			let _record = {
				name: data.name,
				discount: Number(data.discount),
				prices: data.prices.map(entry => ({ 
					product_id: Number(entry.product_id),
					discount: Number(entry.discount),
					unit_price: Number(entry.unit_price)
				}))
			};
			if (old_data)
				return await api.call(api.update_price_list, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_price_list, data.company_id, _record);
		},
		handleEvents(ev)
		{
			let submenu, header, record;
			if (submenu = findByAttr(ev.target, 'hash'))
				router.route(submenu.getAttribute('hash'));
			else if (header = findByAttr(ev.target, 'data-index'))
				this.sortPage(header.getAttribute('data-index'));
			else if (record = findByAttr(ev.target, 'data-id')) {
				ev.stopPropagation();	// Evita que handlers de outros cruds na workarea (ex: grupos) tratem o clique
				try {
					const id = JSON.parse(record.getAttribute('data-id'));
					if (id[2] === 'customer') {
						_showCustomerPriceDetail(id[0], id[1], this);
						return;
					}
				} catch (_) {}
				this.loadRecord(record.getAttribute('data-id')).then((data) => data != null && this.editRecord.call(this, data));
			}
		},
	});
	
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Lista', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da lista' },
		{ index: 3, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome da lista' },
		{ index: 4, field: 'avg_discount', label: '% Desconto', types: [types.number(2)], placeholder: '0,00', title: 'Média percentual de desconto' },
		{ index: 5, field: 'sku_count', label: 'Qtd SKUs', types: [types.number(0, 2)], placeholder: '0', title: 'Quantidade de SKUs' },
	];

	const workarea = document.getElementById('workarea');
	workarea.innerHTML = '';
	const wrapper = document.createElement('div');
	wrapper.className = 'price-lists-wrapper';
	const panel = document.createElement('div');
	panel.className = 'customer-prices-panel fsb fac mtm mbm';
	panel.innerHTML = `
		<fieldset class="customer-prices-fieldset">
			<legend>Tabela de preço por cliente</legend>
			<label>Empresa <input id="cp_company_id" type="text" list="cp_companies"></label>
			<label>Cliente <input id="cp_customer_id" type="text" list="cp_customers"></label>
			<datalist id="cp_companies"></datalist>
			<datalist id="cp_customers"></datalist>
			<button type="button" class="bn_cp_download button">Baixar modelo CSV</button>
			<button type="button" class="bn_cp_import button">Importar CSV</button>
			<input type="file" id="cp_file_input" accept=".csv" style="display:none">
		</fieldset>
	`;
	wrapper.appendChild(panel);
	const crudContainer = document.createElement('div');
	wrapper.appendChild(crudContainer);
	workarea.appendChild(wrapper);

	let operations = [
		{ hash: '#apagar-tabela', label: 'Apagar&nbsp;tabela' }
	];
	router.set('#apagar-tabela', () => _apagarTabela(price_lists_crud));

	price_lists_crud.run(
		'price_lists',
		'Listas de Preços',
		crudContainer,
		view,
		form,
		fieldspecs,
		operations
	).then(() => {
		_setupCustomerPrices(panel, price_lists_crud);
	}).catch(e => {
		console.error('price-lists run:', e);
	});

};

async function _showCustomerPriceDetail(companyId, customerId, crudRef)
{
	const [pricesResp, companiesResp, customersResp] = await Promise.all([
		api.call(api.customer_prices_list, companyId, customerId),
		db.list('companies').catch(() => []),
		db.list('customers').catch(() => [])
	]);
	const rows = Array.isArray(pricesResp) ? pricesResp : [];
	const prices = rows.map(r => ({
		product_id: r.product_id,
		discount: r.discount ?? 0,
		unit_price: r.unit_price
	}));
	const data = {
		company_id: companyId,
		id: customerId,
		customer_id: customerId,
		name: 'Tabela por cliente',
		discount: '',  // vazio = usa desconto por item; preenchido = aplica a todos
		prices
	};
	const flat = flatten(data, 'prices');

	const fs = record.edit(form, async (updated_data, old_data) => {
		if (!old_data?.customer_id) return false;
		const deep = deepen(updated_data, 'prices');
		const headerVal = deep.discount;
		const headerFilled = headerVal != null && String(headerVal).trim() !== '' && !isNaN(Number(headerVal));
		const headerDiscount = headerFilled ? Math.min(100, Math.max(0, Math.round(Number(headerVal) * 100) / 100)) : null;
		const clampDiscount = (v) => Math.min(100, Math.max(0, Math.round((v || 0) * 100) / 100));
		const pr = (deep.prices || []).map(p => {
			const rawItem = p.discount != null && String(p.discount).trim() !== '' && !isNaN(Number(p.discount)) ? Number(p.discount) : null;
			const itemDiscount = headerFilled ? headerDiscount : (rawItem !== null ? clampDiscount(rawItem) : 0);
			return {
				product_id: Number(p.product_id),
				unit_id: p.unit_id != null ? Number(p.unit_id) : undefined,
				unit_price: Number(p.unit_price),
				discount: itemDiscount
			};
		}).filter(p => p.product_id && !isNaN(p.unit_price));
		const resp = await api.call(api.customer_prices_replace, companyId, customerId, pr);
		notify(`${resp?.count ?? 0} preço(s) salvo(s).`);
		await crudRef.loadPage();
		return true;
	}, flat);

	setTimeout(() => {
		const n = document.querySelector('#price-list');
		if (n) {
			const ec = n.querySelector('#company_id');
			const cc = n.querySelector('#customer_id');
			if (ec) ec.disabled = true;
			if (cc) cc.disabled = true;
		}
	}, 150);
}

async function _apagarTabela(crudRef)
{
	const selection = crudRef.getSelection();
	const customerIds = selection.filter(a => Array.isArray(a) && a[2] === 'customer');
	if (!customerIds.length) {
		notify('Selecione tabela(s) por cliente para apagar.');
		return;
	}
	ask(`Apagar ${customerIds.length} tabela(s) de preço por cliente?`, 'Confirmar', async (key) => {
		if (key !== 'Y') return;
		for (const [companyId, customerId] of customerIds) {
			await api.call(api.customer_prices_delete, companyId, customerId);
		}
		notify('Tabela(s) apagada(s).');
		await crudRef.loadPage();
	});
}

async function _setupCustomerPrices(panel, crudRef)
{
	const db = (await import('../../versa/db.js')).default;
	const inpCompany = panel.querySelector('#cp_company_id');
	const inpCustomer = panel.querySelector('#cp_customer_id');
	const dlCompanies = panel.querySelector('#cp_companies');
	const dlCustomers = panel.querySelector('#cp_customers');
	const fileInput = panel.querySelector('#cp_file_input');
	if (!inpCompany || !inpCustomer || !fileInput) return;

	let companies = [];
	try { companies = await db.list('companies') || []; } catch (_) {}
	companies = Array.isArray(companies) ? companies : [];
	dlCompanies.innerHTML = companies.map(c => `<option value="${c.id || ''}">${c.nick || c.name || c.id || ''}</option>`).join('');

	function resolveCompanyId(val) {
		if (!val) return null;
		const c = companies.find(x => x.id === val || x.nick === val || (x.name && x.name.includes && x.name.includes(val)));
		return c?.id || null;
	}
	function getCompanyCustomerIds() {
		const companyId = resolveCompanyId(inpCompany.value);
		let customerId = inpCustomer.value?.trim();
		if (customerId && /^\d+$/.test(customerId)) customerId = parseInt(customerId, 10);
		else {
			const opt = Array.from(inpCustomer.list?.options || []).find(o => (o.value === customerId) || (o.textContent && o.textContent.trim() === customerId));
			if (opt) customerId = parseInt(opt.value, 10);
		}
		return [companyId, customerId];
	}

		inpCompany.addEventListener('change', async () => {
		const companyId = resolveCompanyId(inpCompany.value);
		if (!companyId) { dlCustomers.innerHTML = ''; inpCustomer.value = ''; crudRef.filter = {}; }
		else {
			const q = `?filter=company_id*eq*${companyId}&limit=0`;
			const resp = await api.call(api.list_customers, q);
			if (resp && Array.isArray(resp)) {
				db.set('customers', resp);
				dlCustomers.innerHTML = resp.map(c => `<option value="${c.id}" data-company="${c.company_id}">${(c.nick || c.name || c.id)}</option>`).join('');
			}
			inpCustomer.value = '';
			crudRef.filter = { 'field-0': 'company_id', 'value-0': companyId, 'operator-0': 'eq' };
		}
		await crudRef.loadPage(1);
	});

	panel.querySelector('.bn_cp_download')?.addEventListener('click', async () => {
		const [companyId, customerId] = getCompanyCustomerIds();
		if (!companyId || !customerId) { notify('Selecione Empresa e Cliente.'); return; }
		const csv = await api.call(api.customer_prices_template, companyId, customerId);
		if (typeof csv !== 'string') return;
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
		const a = document.createElement('a');
		a.href = URL.createObjectURL(blob);
		a.download = 'tabela_preco_cliente.csv';
		a.click();
		URL.revokeObjectURL(a.href);
		notify('Modelo CSV baixado.');
	});

	panel.querySelector('.bn_cp_import')?.addEventListener('click', () => fileInput.click());

	fileInput.addEventListener('change', async (e) => {
		const file = e.target.files?.[0];
		if (!file) return;
		const [companyId, customerId] = getCompanyCustomerIds();
		if (!companyId || !customerId) { notify('Selecione Empresa e Cliente.'); fileInput.value = ''; return; }
		const csv = await file.text();
		const resp = await api.call(api.customer_prices_import, companyId, customerId, csv);
		if (resp) {
			notify(`${resp.count || 0} preço(s) importado(s).`);
			await crudRef.loadPage();
		}
		fileInput.value = '';
	});
}

export default price_lists;
